import * as React from 'react';
import styled from "styled-components";
import img1 from "../assets/b_30dni.gif";
import img2 from "../assets/b_dlapoczatk.gif";
import img3 from "../assets/b_listy.gif";
import img4 from "../assets/b_czasownikihiszpanskie.gif";
import img5 from "../assets/b_czasowniki2.gif";
import img6 from "../assets/b_czasy.gif";
import img7 from "../assets/b_idiomy.gif";
import img8 from "../assets/b_idiomy2.gif" ;
import img9 from "../assets/b_idiomy3.gif";
import img10 from "../assets/b_krotka.gif";
import img11 from "../assets/b_rozmowki3.gif";
import img12 from "../assets/b_rozmowki.gif";
import img13 from "../assets/b_rozmowki2.gif";

const SBooks = styled.div`
  flex: 1; /* Allows main content to take up the remaining horizontal space */
  padding: 5px 30px;

  .files-list {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  
  .file-item {
    display: grid;
    grid-template-columns: 100px auto;
    gap: 10px;  /* Adjust space between columns */
    align-items: start;
    margin-bottom: 15px;  /* Adjust space between rows */
    background-color: #f5f5f5; /* Light gray background */
    border: 1px solid #e0e0e0; /* Light gray border */
    border-radius: 5px; /* Optional: Adds rounded corners */
    padding: 5px;
  }
`;

function BookList(props) {
  return (
    <div className="files-list">
    {props.data.map(item => (
        <div key={item.id} className="file-item">
            <img src={item.img} alt={item.name}/>
            <div dangerouslySetInnerHTML={{ __html: item.desc }} />
        </div>
    ))}
</div>
  );
}

const Book = () => {
  const data = [
    {
      id: "1",
      img: img1,
      desc: "<b>Język hiszpański w 30 dni</b><br>Autor: <i>Carmen Konigbauer, Harda Kuwer</i><br>Tłumacz: <i>Zagórowska Kamila</i><br>Wydawnictwo: <i>Langenscheidt</i><br><br>Błyskawiczny kurs językowy z kasetą dla samouków. Składa się z 30 lekcji, które obejmują dialog wraz z tłumaczeniem na język polski, ćwiczenia, słowniczek i komentarz gramatyczny. Pozwoli poznać reguły obcego języka oraz podstawowe słownictwo, po każdych pięciu lekcjach można sprawdzić postępy w nauce, rozwiązując specjalny test cząstkowy."
    },
    {
      id: "2",
      img: img2,
      desc: "<b>Język hiszpański dla początkujących</b><br>Autor: <i>Oskar Perlin</i><br>Wydawnictwo: <i>Wiedza Powszechna</i><br><br>Książka zawiera 60 lekcji, teksty przybliżające kraje hiszpańskojęzyczne, objaśnienia wyrazów i zwrotów, komentarz gramatyczny, ćwiczenia oraz klucz do tekstów i ćwiczeń."
    },
    {
      id: "3",
      img: img3,
      desc: "<b>100 listów. Język hiszpański</b><br>Autor: <i>Birgit Abegg, Juliana E. Moreno</i><br>Wydawnictwo: <i>Langenscheidt</i><br><br>Książka dla wszystkich ambitnych i aktywnych zawodowo, którzy chcą prowadzić korespondencję biznesową w języku hiszpańskim w sposób profesjonalny, jak również dla tłumaczy, studentów kierunków ekonomicznych i administracji."
    },
    {
      id: "4",
      img: img4,
      desc: "<b>Czasowniki hiszpańskie</b><br>Tłumacz: <i>Arkadiusz Gmitrzak i inni</i><br>Wydawnictwo: <i>Philip Wilson</i><br><br>Książka zawiera podstawowe wiadomości o różnych formach i konstrukcjach czasownikowych, czasach, trybach w języku hiszpańskim- pełną odmianę ponad 200 czasowników hiszpańskich - indeks liczący 2400 powszechnie używanych czasowników, odsyłający do odpowiednich wzorców odmiany."
    },
    {
      id: "5",
      img: img5,
      desc: "<b>Czasowniki hiszpańskie</b><br>Autor: <i>Jacek Perlin, Maria Milewska-Rodrigues</i><br>Wydawnictwo: <i>Wiedza Powszechna</i><br><br>Książka zawiera podstawowe wiadomości o czasach, trybach i stronach, czasowniki regularne i nieregularne, tabele koniugacyjne, rekcję."
    },
    {
      id: "6",
      img: img6,
      desc: "<b>Czasy i czasowniki hiszpańskie</b><br>Autor: <i>Carlos Segoviano</i><br>Tłumacz: <i>Alina Rozynek</i><br>Wydawnictwo: <i>PONS</i><br><br>Książka zawiera jasno sformułowane reguły, które pomogą utworzyć każdą formę czasownika a także najważniejsze czasowniki hiszpańskie w przejrzystych tabelach."
    },
    {
      id: "7",
      img: img7,
      desc: "<b>Idiomy polsko-hiszpańskie</b><br>Autor: <i>Jesus Pulido Ruiz, Dorota Leniec-Lincow</i><br>Wydawnictwo: <i>Wydawnictwo Naukowe PWN</i><br><br>Książka zawiera: polskie i hiszpańskie idiomy i wyrażenia podobne, prawie 1800 haseł głównych, około 2500 wyrażeń, wskazówki objaśniające i definicje w języku polskim i hiszpańskim, przykłady użycia haseł w kontekście w języku polskim i hiszpańskim, pełny indeks w języku polskim i hiszpańskim."
    },
    {
      id: "8",
      img: img8,
      desc: "<b>1500 idiomów hiszpańskich</b><br>Autor: <i>Abel A. Soriano, Kamila Zagórowska</i><br>Wydawnictwo: <i>Langenscheidt</i><br><br>Książka zawiera najważniejsze idiomy hiszpańskie uporządkowane tematycznie według słów-kluczy, każdy idiom opatrzony tłumaczeniem i przykładami użycia, obszerny indeks, liczne zabawne ilustracje przedstawiające dosłowne znaczenia idiomów, dla uczących się języka hiszpańskiego na poziomie średnio zaawansowanym i zaawansowanym."
    },
    {
      id: "9",
      img: img9,
      desc: "<b>Idiomy hiszpańskie</b><br>Autor: <i>Małgorzata Koszla - Szymańska, Jesus Pulido Ruiz</i><br>Wydawnictwo: <i>Wiedza Powszechna</i><br><br>Książka zawiera 1200 wyrażeń i zwrotów frazeologicznych języka hiszpańskiego. Przeznaczona jest dla osób średnio zaawansowanych w nauce języka hiszpańskiego, które pragną znacznie pogłębić jego znajomość. Książka  składa się z dwóch części. W pierwszej - alfabetycznie podano wyrazy hasłowe będące ośrodkiem związku frazeologicznego oraz ich polskie odpowiedniki. Pod tymi hasłami umieszczono idiomy - każdy z tłumaczeniem znaczenia na język hiszpański i język polski, a także - co ważne - przykłady ich użycia w zdaniach.<br>W części drugiej znalazły się ćwiczenia pomagające opanować użycie idiomów w zdaniach oraz klucz do ćwiczeń."
    },
    {
      id: "10",
      img: img10,
      desc: "<b>Krótka gramatyka - Język hiszpański</b><br>Autor: <i>Astrid Bohringer</i><br>Wydawnictwo: <i>Langenscheidt</i><br><br>Książka zawiera najważniejsze zasady, liczne przykłady z polskimi tłumaczeniami oraz spis alfabetyczny terminów gramatycznych - książka dla uczących się na poziomie podstawowym i średnio zaawansowanym."
    },
    {
      id: "11",
      img: img11,
      desc: "<b>Rozmówki hiszpańskie</b><br>Tłumacz: <i>Jesus Pulido Ruiz</i><br>Wydawnictwo: <i>Philip Wilson</i><br><br>Książka zawiera niezbędne informacje turystyczne, słowniczek 5000 haseł, podstawy gramatyki oraz to co warto zobaczyć i wiedzieć."
    },
    {
      id: "12",
      img: img12,
      desc: "<b>Praktyczne rozmówki - Język hiszpański</b><br>Tłumacz: <i>Anna Gilewska</i><br>Wydawnictwo: <i>Langenscheidt</i><br><br>Książka zawiera zwroty i słówka niezbędne w podróży, praktyczny podział tekstu, tekst obcojęzyczny w prostym zapisie fonetycznym, wiadomości o kraju, jego mieszkańcach i obyczajach, łatwy do opanowania skrót gramatyki."
    },
    {
      id: "13",
      img: img13,
      desc: "<b>Rozmówki ilustrowane - Język hiszpański</b><br>Tłumacz: <i>Anna Gilewska</i><br>Wydawnictwo: <i>Langenscheidt</i><br><br>Książka zawiera ponad 7 000 słów i zwrotów, które pomogą za granicą w każdej sytuacji. Ponadto zawiera tekst obcojęzyczny w prostym zapisie fonetycznym, wiadomości o kraju, jego mieszkańcach i obyczajach, łatwy do opanowania skrót gramatyki."
    }
  ];

  return (
  <SBooks>
    <h5>Książki</h5>
    <BookList data={data} />
  </SBooks>
  )
};

export default Book;